// @mui
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
//
import Link from 'next/link';
import Iconify from '../../../components/Iconify';
import Image from '../../../components/Image';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  backgroundColor: theme.palette.warning.lighter,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

// ----------------------------------------------------------------------

export default function BlogWelcome() {
  return (
    <RootStyle>
      <CardContent
        sx={{
          color: 'grey.800',
          p: { md: 0 },
          pl: { md: 5 }
        }}
      >
        <Typography gutterBottom variant="h4">
          Hệ thống,
          <br /> ÔN THI GPLX
          <br />Ô TÔ, XE MÁY
        </Typography>

        <Typography variant="body2" sx={{ pb: { xs: 3, xl: 5 }, maxWidth: 480, mx: 'auto' }}>
          Những câu hỏi ôn tập và đề thi chuẩn nhất trong tháng. Bạn có thể tham gia ngay trong ngày hôm nay...
        </Typography>
        <Stack direction={"row"} spacing={2} sx={{ justifyContent: { md: 'flex-start', xs: 'center' } }}>
          <Link href={"/thi-gplx/o-to/"} passHref><Button color='primary' startIcon={<Iconify icon={"ion:car"} />} variant="contained">Ô tô</Button></Link>
          <Link href={"/thi-gplx/xe-may/"} passHref><Button color='info' startIcon={<Iconify icon={"healthicons:basic-motorcycle"} />} variant="contained">Xe máy</Button></Link>
          <Link href={"/thi-tinh-huong/"} passHref><Button color='warning' startIcon={<Iconify icon={"ph:eye"} />} variant="contained">Mô phỏng</Button></Link>
        </Stack>
      </CardContent>

      <Image alt="" src="/illustrations/mobile-app.png"
        sx={{
          p: 3,
          height: 260,
          margin: { xs: 'auto', md: 'inherit' },
          width: 260
        }}
      />
    </RootStyle>
  );
}
